module.exports = __webpack_public_path__ + "static/media/hiring-7062502.5c3027b9.jpg";